import { useEffect, useRef } from 'react';

export default function PopupModal({
  open,
  onClose,
  title,
  description,
  primary = null,   // { label, href } - opens external link in new tab
  secondary = null  // { label, onClick } - callback (e.g. navigate)
}) {
  const modalRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    function handleOutside(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    }
    function handleKey(e) {
      if (e.key === 'Escape') onClose();
    }

    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('keydown', handleKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="custom-modal-overlay"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        zIndex: 1050,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem'
      }}
      aria-hidden={!open}
    >
      <div
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-label={title || 'Modal'}
        className="custom-modal-card"
        style={{
          background: '#fff',
          borderRadius: '8px',
          maxWidth: 560,
          width: '100%',
          boxShadow: '0 6px 24px rgba(0,0,0,0.25)',
          padding: '1.25rem'
        }}
      >
        <div style={{ textAlign: 'center' }}>
          {/* {title && <h4 style={{ marginBottom: '0.5rem' }}>{title}</h4>} */}
          {description && <p style={{ color: '#555' }}>{description}</p>}

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '1rem' }}>
            {primary && primary.href && (
              <a
                className="c_button"
                style={{ textDecoration: 'none', color: 'white' }}
                href={primary.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => onClose()}
                role="button"
                aria-label={primary.label || 'Open link'}
              >
                {primary.label || 'Abrir'}
              </a>
            )}

            {secondary && typeof secondary.onClick === 'function' && (
              <button
                type="button"
                className="c_button"
                onClick={() => {
                  try { secondary.onClick(); } finally { onClose(); }
                }}
              >
                {secondary.label || 'Aceptar'}
              </button>
            )}

            {/* Close button */}
            {/* <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cerrar
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
}